"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
function Redirect(_ref) {
  let {
    to
  } = _ref;
  (0, _react.useEffect)(() => {
    window.location.href = to;
  }, [to]);
  return null;
}
var _default = exports.default = Redirect;